import { motion } from "framer-motion";
import Reveal, { stagger, fadeUp } from "@/components/Reveal";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "SORTD opened doors we'd been knocking on for over a year. Within months, conversations became contracts. Their hands-on approach is unlike any consultancy we've worked with.",
    name: "Sarah Mitchell",
    role: "Director, Real Estate Agency",
    city: "Auckland, NZ",
  },
  {
    quote:
      "The sales training reshaped how our team handles every conversation. Our close rate lifted noticeably within the first quarter. Practical, sharp, and zero fluff.",
    name: "James O'Connor",
    role: "Managing Director",
    city: "Sydney, AU",
  },
  {
    quote:
      "From prospecting to follow-ups, they took the pressure off completely. Our pipeline finally moves without me chasing every lead. You run the business — they really do get the growth sorted.",
    name: "Priya Nair",
    role: "Founder, SME Services",
    city: "Melbourne, AU",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-20 sm:py-28 bg-slate-50/70 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <Reveal>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 leading-tight">
              Client success stories
            </h2>
          </Reveal>
          <Reveal>
            <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
              Hear from leaders across New Zealand and Australia who transformed
              their pipeline with SORTD.
            </p>
          </Reveal>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              variants={fadeUp}
              data-testid={`testimonial-card-${i}`}
              className="bg-white rounded-2xl border border-slate-200 p-8 flex flex-col hover:shadow-lg hover:shadow-slate-900/5 transition-shadow duration-300"
            >
              <Quote className="w-8 h-8 text-emerald-200 mb-5" />
              <blockquote className="text-sm sm:text-base text-slate-700 leading-relaxed flex-1">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 pt-6 border-t border-slate-100 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-emerald-600 text-white font-display font-bold text-sm flex items-center justify-center shrink-0">
                  {t.name.split(" ").map((n) => n[0]).join("")}
                </span>
                <span>
                  <span className="block text-sm font-bold text-slate-900">{t.name}</span>
                  <span className="block text-xs text-slate-500 mt-0.5">
                    {t.role} • {t.city}
                  </span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
